import store from '@/store'

export const getFarmPath = (farm, route, append) => {
  const isConsultant = store.getters['account/isConsultant']
  const isClient = store.getters['account/isClient']

  const AcClientId = route.params.ac_client_id
  const clientId = route.params.client_id
  const companyId = route.params.company_id
  const farmId = farm ? farm.id : route.params.farm_id

  let path
  if (isClient) {
    path = `/app/companies/${companyId}/farms/${farmId}`
  } else if (isConsultant && clientId) {
    path = `/app/clients/${clientId}/companies/${companyId}/farms/${farmId}`
  } else if (AcClientId && clientId) {
    path = `/app/activities/${AcClientId}/clients/${clientId}/companies/${companyId}/farms/${farmId}`
  } else {
    path = `/app/companies/${companyId}/farms/${farmId}`
  }
  return append ? `${path}/${append}` : path
}
